import React, { useState } from 'react';
import Layout from '../../../components/layouts/Layout';
import { useTranslation } from 'react-i18next';
import CategoriesSection from '../../../components/store/reusable/category/CategoriesSection';
import { useSearchParams } from 'react-router-dom';
import { StoreStatus } from '../../../types/enum/storeStatus';
import AdminStoresOverViewParent from '../../../components/admin/stores/AdminStoresOverViewParent';
import { cities } from '../../../data/cities';
import SearchForm from '../../../components/admin/stores/SearchFormForStores';
import InCompletesStoresView from '../../../components/admin/stores/InCompletesStoresView';

const AdminViewStoresPage: React.FC = () => {
      const { t } = useTranslation();
      const [searchParams] = useSearchParams();
      const category = searchParams.get('category')?? StoreStatus.APPROVED;
      const categories = [
        { id: StoreStatus.APPROVED, name: t(StoreStatus.APPROVED) },
        { id: StoreStatus.PENDING, name: t(StoreStatus.PENDING) },
        { id: StoreStatus.SUSPENDED, name: t(StoreStatus.SUSPENDED) },
        { id: StoreStatus.REJECTED, name: t(StoreStatus.REJECTED) },
        { id: StoreStatus.INCOMPLETED, name: t(StoreStatus.INCOMPLETED) },
        ];

        
  const renderTabContent = () => {
    switch (category) {
      case StoreStatus.APPROVED:
      return <div>
        <><AdminStoresOverViewParent status={StoreStatus.APPROVED}/></>
      </div>;
      case StoreStatus.PENDING:
         return <div>
        <><AdminStoresOverViewParent status={StoreStatus.PENDING}/></>
      </div>;
      case StoreStatus.SUSPENDED:
         return <div>
        <><AdminStoresOverViewParent status={StoreStatus.SUSPENDED}/></>
      </div>;
      case StoreStatus.REJECTED:
         return <div>
        <><AdminStoresOverViewParent status={StoreStatus.REJECTED}/></>
      </div>;
      case StoreStatus.INCOMPLETED:
        return <><InCompletesStoresView/></>;
    }
  };

  return (
    <Layout title={t("layout_titles.products")} headline={""}>
      <div className=''>
        <CategoriesSection
        selectedCategory={category}
        categories={categories}
        buttonAddLinkPath={""}
        buttonLinkPath={""}
        buttonLabel=''
        showAdd={false}
        notShowAddButton={true}
        showAllLable={false}
      />
      {
        category !== StoreStatus.INCOMPLETED &&
        <div>
        <SearchForm cities={cities}/>
      </div>
      }
      </div>
        {/* Tab Content */}
      <div className="mt-6">
        {renderTabContent()}
      </div>
    </Layout>
  );
};

export default AdminViewStoresPage;
